import React, { useCallback, useEffect, useState } from "react";
import { Mail, MailOpen, Trash2 } from "lucide-react";
import { api } from "../lib/api";

function fmt(iso) {
  return new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", dateStyle: "medium", timeStyle: "short" });
}

export default function ContactInbox({ onUnread, flash }) {
  const [messages, setMessages] = useState([]);
  const [openId, setOpenId] = useState(null);

  const load = useCallback(async () => {
    const { data } = await api.get("/admin/messages");
    setMessages(data.messages);
    onUnread(data.unread);
  }, [onUnread]);

  useEffect(() => {
    load();
  }, [load]);

  const open = async (m) => {
    setOpenId((p) => (p === m.id ? null : m.id));
    if (!m.read) {
      await api.post(`/admin/messages/${m.id}/read`);
      load();
    }
  };

  const remove = async (m) => {
    await api.delete(`/admin/messages/${m.id}`);
    flash("Message deleted");
    load();
  };

  if (messages.length === 0) {
    return <div className="inbox-empty" data-testid="inbox-empty">No contact messages yet.</div>;
  }

  return (
    <div className="inbox-list" data-testid="inbox-list">
      {messages.map((m) => (
        <div key={m.id} className={`inbox-item ${m.read ? "" : "unread"}`} data-testid={`inbox-item-${m.id}`}>
          <div className="inbox-head" onClick={() => open(m)} data-testid={`inbox-open-${m.id}`}>
            <span className="inbox-icon">{m.read ? <MailOpen size={16} /> : <Mail size={16} />}</span>
            <div className="inbox-meta">
              <div className="inbox-name">{m.name}</div>
              <div className="inbox-email">{m.email}</div>
            </div>
            <div className="inbox-date">{fmt(m.created_at)}</div>
            <button
              className="mini-btn clear"
              onClick={(e) => {
                e.stopPropagation();
                remove(m);
              }}
              aria-label="Delete"
              data-testid={`inbox-delete-${m.id}`}
            >
              <Trash2 size={13} />
            </button>
          </div>
          {openId === m.id && (
            <div className="inbox-body" data-testid={`inbox-body-${m.id}`}>
              {m.message}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
